import { observer } from 'mobx-react';
import { default as React, useContext } from 'react';
import { Container, Spinner } from 'react-bootstrap';
import './SpinnerWrapper.css';
import { RootStoreContext } from '../stores/RootStore';

export const FULL_PAGE = 'fullPage';

export const SpinnerWrapper = observer(({ name }) => {
  const { spinnerStore: { isVisible } } = useContext(RootStoreContext);

  const renderSpinner = () => (
    <>
      <Container fluid className="overlay" />
      <Spinner animation="border" variant="info"/>
    </>
  );

  return isVisible(name) ? renderSpinner() : null;
});
